import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObj: {
    SheetNo: 0,
    Loc: "",
    LocName: "",
    Date: new Date(),
    ReferenceNo: "",
    A_DocStat: "ENTER",
  },
  SummaryObj: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
  },
};

const SlicePhysicalStock = createSlice({
  name: "SlicePhysicalStock",
  initialState: { value: initialState },

  reducers: {
    Set_SlicePhysicalStock_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_SlicePhysicalStock_HeadObj_Init: (state, action) => {
      state.value.HeadObj = initialState.HeadObj;
    },

    Set_SlicePhysicalStock_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    },
    Slice_PhysicalStock_Init: (state) => {
      state.value = initialState;
    },

    Set_SlicePhysicalStock_HeadObj_New_Set: (state, action) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.Loc = action.payload.Loc;
      state.value.HeadObj.Date = action.payload.Date;
      state.value.HeadObj.ReferenceNo = action.payload.ReferenceNo;
    },
    Set_SlicePhysicalStock_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
    Set_SlicePhysicalStock_HeadObject_SheetNo_A_DocStat: (state, action) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_SlicePhysicalStock_HeadObj,
  Set_SlicePhysicalStock_SummaryObj,
  Set_SlicePhysicalStock_HeadObject_A_DocStat,
  Set_SlicePhysicalStock_HeadObject_SheetNo_A_DocStat,
  Slice_PhysicalStock_Init,
  Set_SlicePhysicalStock_HeadObj_Init,
  Set_SlicePhysicalStock_HeadObj_New_Set,
} = SlicePhysicalStock.actions;
export default SlicePhysicalStock.reducer;
